@import "../../../../styles/variables";
:host {
  display: flex;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: var(--light-overlay, rgba(0, 0, 0, 0.4));
  z-index: 1000;
  align-items: center;
  justify-content: center;

  &.hidden {
    display: none;
  }
}

.spinner-dialog {
  background-color: $svs-white;
  padding: 24px;

  .loading-icon {
    position: relative;
    font-size: 100px;
    height: 100px;
    width: 100px;
  }
}
